import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    service: {
      width: '100%',
      padding: theme.spacing(2),
      marginTop: theme.spacing(1),
      border: `2px solid `,
      borderColor: theme.palette.grey[800],
      color: theme.palette.grey[600],
      textAlign: 'start',
      borderRadius: '10px',
    },
    selected: {
      borderColor: theme.palette.primary.main,
      color: theme.palette.text.primary,
    },
  }),
);

export default useStyles;
